// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { CUSTOM_LEADS_ACL_OPTION, normalizeAgentLeadsCustomOptions } from '@/utilities/agentLeadsQuota';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaUserPlus,
} from '@/features/acl-settings/aclSettingsUi';

const AgentLeadsCustomAclModal = ({
  show,
  onHide,
  initialOptions,
  optionsConfigured = false,
  onSave,
  limitedByParent = false,
  canGrantCustomLeads = true,
}) => {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    if (!show) return;
    if (!canGrantCustomLeads) {
      setEnabled(false);
      return;
    }
    if (!optionsConfigured) {
      setEnabled(true);
      return;
    }
    const options = normalizeAgentLeadsCustomOptions(Array.isArray(initialOptions) ? initialOptions : []);
    setEnabled(options.includes(CUSTOM_LEADS_ACL_OPTION));
  }, [show, initialOptions, optionsConfigured, canGrantCustomLeads]);

  const handleReset = () => setEnabled(!!canGrantCustomLeads);

  const handleSave = () => {
    onSave({ edit_options: enabled && canGrantCustomLeads ? [CUSTOM_LEADS_ACL_OPTION] : [] });
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Agent Leads — Custom Leads"
      icon={FaUserPlus}
      description="When Custom Leads is on, this user can type a lead count while creating a call centre user. When it is off, that user gets 100 leads."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={!canGrantCustomLeads}
    >
      <AclModalSection
        icon={FaUserPlus}
        title="Custom Leads"
        subtitle="Checked by default. Uncheck to force 100 leads on new call centre users."
      >
        {!canGrantCustomLeads ? (
          <p className="acl-modal-empty">
            You do not have permission to grant custom leads.
          </p>
        ) : (
          <AclModalOptionCheck
            id="agent-leads-acl-custom"
            label="Custom Leads"
            description="Allow a custom lead count when creating a call centre user. Off means 100."
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default AgentLeadsCustomAclModal;
